import __var_0__ from '@stdlib/math/base/special/exp';
import __var_1__ from '@stdlib/math/base/special/gamma';
import __var_2__ from '@stdlib/math/base/special/ln';
import __var_3__ from '@stdlib/constants/math/float32-max';
import __var_4__ from '@stdlib/constants/math/float64-sqrt-two-pi';
import __var_5__ from './stirling.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var exp = __var_0__;
var gamma = __var_1__;
var ln = __var_2__;
var FLOAT32_MAX = __var_3__;
var SQRT_TWO_PI = __var_4__;
var stirling = __var_5__;


// MAIN //

/**
* Computes the regulated gamma function.
*
* @private
* @param {number} x - input value
* @returns {number} function value
*/
function gamstar( x ) {
	if ( x >= 3.0 ) {
		return exp( stirling(x) );
	}
	if ( x > 0.0 ) {
		return gamma(x) / ( exp( -x + ( ( x-0.5 ) * ln(x) ) ) * SQRT_TWO_PI );
	}
	// Case: x <= 0.0
	return FLOAT32_MAX;
}


// EXPORTS //
export default gamstar;
